import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinindapur() {



  const cardData =
  {
    keyword: 'Bus On Rent in Indapur',
    heading: 'Sanavi Travels: Bus On Rent in Indapur',
    headingDescription: 'Sanavi Travels offers reliable Bus On Rent in Indapur, providing safe, comfortable, and spacious transportation for families, groups, corporate trips, school excursions, weddings, and tourist travel in and around Indapur. Our fleet of well-maintained AC and non-AC buses, mini buses, and luxury coaches ensures smooth rides, ample seating, and sufficient luggage space for a hassle-free journey. With professional drivers, flexible one-way and round-trip bus rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Indapur, Pune, and nearby areas, making it ideal for local sightseeing, outstation trips, corporate events, and group tours. Choose Sanavi Travels for trusted bus rental services in Indapur, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Indapur with Sanavi Travels',


"topPlaces": [
  {
    "title": "Indapur Town",
    "description": "Indapur is a historic town in Pune district, Maharashtra, known for its rich cultural heritage and strategic location on the banks of the Bhima River. It has a legacy dating back to the Maratha and Mughal periods and serves as a gateway to the rural landscapes and forts of eastern Pune. The town offers visitors a mix of historical sites, local markets, and serene riverside scenery."
  },
  {
    "title": "Indreshwar Mandir",
    "description": "Indreshwar Mandir is a prominent temple in Indapur dedicated to Lord Shiva. It is a focal point for devotees, especially during festivals like Mahashivratri. The temple’s traditional architecture and spiritual ambiance attract pilgrims and tourists seeking peace and religious experience."
  },
  {
    "title": "Bhima Riverfront",
    "description": "The banks of the Bhima River in Indapur provide tranquil spots for relaxation, morning walks, and picnics. During the monsoon, the river swells and the surrounding greenery becomes lush, making it ideal for photography and nature walks."
  },
  {
    "title": "Historic Forts Nearby",
    "description": "Indapur is surrounded by several historical forts from the Maratha era, such as the Chavand and Bhorgiri forts. These forts offer trekking opportunities, panoramic views of the landscape, and insights into regional history and military architecture."
  },
  {
    "title": "Local Markets and Handicrafts",
    "description": "Indapur’s markets reflect the region’s rural lifestyle, offering fresh agricultural produce, traditional handicrafts, and local delicacies. Visitors can explore these markets to understand local culture and take home souvenirs."
  },
  {
    "title": "Chikhali Fort (Nearby)",
    "description": "Chikhali Fort is a historic fort near Indapur, showcasing Maratha architectural style. It attracts history enthusiasts and trekkers who want to explore ancient battlements and enjoy panoramic views of the surrounding plains."
  },
  {
    "title": "Agricultural Fields and Rural Tourism",
    "description": "The region around Indapur is fertile and primarily agricultural, with farms producing sugarcane, vegetables, and grains. Visitors can witness traditional farming practices and experience rural life firsthand, making it ideal for agro-tourism experiences."
  },
  {
    "title": "Temples of Indapur Taluka",
    "description": "Indapur Taluka is home to numerous small temples and shrines dedicated to local deities, reflecting the spiritual and cultural fabric of the region. These sites host festivals and rituals throughout the year."
  },
  {
    "title": "Nature Trails and Hill Views",
    "description": "The surrounding hills and natural trails provide trekking and walking opportunities. Travelers can enjoy scenic vistas of the Bhima river valley, forests, and rural landscapes, especially during sunrise and sunset."
  },
  {
    "title": "Local Cuisine and Eateries",
    "description": "Indapur offers traditional Maharashtrian cuisine with local eateries serving dishes like bhakri, vadi, and regional sweets. Sampling the local food provides an authentic cultural and culinary experience."
  }
]
,



"services": [
{
"name": "Bus On Rent in Indapur",
"description": "Bus On Rent in Indapur provides reliable and comfortable bus services for local travel, group tours, religious trips, and family outings. With well-maintained buses, professional drivers, and flexible itineraries, it ensures a safe, punctual, and hassle-free travel experience. Ideal for tourists, corporate groups, wedding parties, and school trips, this service emphasizes convenience, passenger comfort, and a smooth journey within Indapur and surrounding areas."
},
{
"name": "Bus Hire Indapur",
"description": "Bus Hire Indapur offers flexible and affordable bus rental services for sightseeing, corporate events, weddings, school trips, and group travel. Spacious seating, modern interiors, and professional drivers ensure passengers enjoy a comfortable and safe journey. Transparent pricing and organized scheduling make it a preferred choice for families, tourists, and organizations traveling in and around Indapur."
},
{
"name": "AC Bus Indapur",
"description": "AC Bus Indapur provides a comfortable and refreshing travel experience with fully air-conditioned buses. Ideal for long-distance travel, corporate trips, family tours, and religious journeys, these buses ensure a smooth ride, relaxing interiors, and a premium travel experience for all passengers visiting Indapur and nearby destinations."
},
{
"name": "Luxury Bus Indapur",
"description": "Luxury Bus Indapur offers high-end buses with modern amenities, including reclining seats, ample legroom, and entertainment options. Perfect for VIP travel, corporate outings, weddings, and leisure trips, it combines elegance, comfort, and professional service to provide a memorable and hassle-free travel experience."
},
{
"name": "Wedding Bus Indapur",
"description": "Wedding Bus Indapur provides dedicated buses for wedding guests, pre-wedding events, and destination weddings. Spacious, well-maintained vehicles with professional drivers ensure safe, timely, and comfortable transportation, making it convenient for families and friends traveling together for wedding celebrations in and around Indapur."
},
{
"name": "Corporate Bus Indapur",
"description": "Corporate Bus Indapur offers organized transportation solutions for businesses, including office trips, conferences, team outings, and client visits. With professional drivers, punctual service, and comfortable buses, it ensures smooth and efficient corporate travel in Indapur and surrounding areas."
},
{
"name": "Outstation Bus Indapur",
"description": "Outstation Bus Indapur specializes in long-distance travel to nearby cities, tourist destinations, and hill stations. Comfortable buses, experienced drivers, and flexible itineraries provide safe, convenient, and enjoyable journeys for families, groups, and solo travelers venturing beyond Indapur."
},
{
"name": "Affordable Bus Indapur",
"description": "Affordable Bus Indapur delivers budget-friendly bus services without compromising on safety or comfort. Ideal for families, school trips, corporate groups, and religious tours, it combines economical pricing with well-maintained buses and professional drivers, making it a smart choice for cost-conscious travelers."
},
{
"name": "Chauffeur Driven Bus Indapur",
"description": "Chauffeur Driven Bus Indapur provides professional drivers who manage routes, traffic, and schedules efficiently, allowing passengers to relax throughout the journey. Perfect for corporate trips, family outings, group travel, and special events, it ensures a stress-free and smooth travel experience."
},
{
"name": "Best Bus Service Indapur",
"description": "Best Bus Service Indapur is known for punctuality, clean buses, and customer-focused service. Suitable for family trips, corporate travel, weddings, and tourist excursions, it guarantees safe, comfortable, and reliable transportation with professional drivers for an enjoyable journey every time."
},
{
"name": "Tourist Bus Indapur",
"description": "Tourist Bus Indapur caters to travelers exploring Indapur and nearby attractions. With flexible itineraries, knowledgeable drivers, and comfortable seating, it provides a memorable sightseeing experience, allowing tourists to enjoy cultural, historical, and scenic sites without worrying about logistics or navigation."
},
{
"name": "Group Travel Bus Indapur",
"description": "Group Travel Bus Indapur offers organized transportation for large groups such as families, friends, school trips, and corporate teams. Spacious buses, coordinated planning, and professional drivers ensure safe, comfortable, and timely travel, making group trips smooth and hassle-free."
},
{
"name": "Online Bus Booking Indapur",
"description": "Online Bus Booking Indapur allows travelers to reserve buses quickly and conveniently with instant confirmation. Multiple bus options, transparent pricing, and flexible schedules simplify trip planning for families, corporate clients, and tourists visiting Indapur and nearby regions."
},
{
"name": "Event Bus Indapur",
"description": "Event Bus Indapur provides dedicated bus services for weddings, corporate events, parties, exhibitions, and other special occasions. Comfortable buses, professional drivers, and timely service ensure smooth and organized travel for guests attending events in Indapur and surrounding areas."
},
{
"name": "Indapur Travel Bus",
"description": "Indapur Travel Bus offers comprehensive travel solutions for local sightseeing, outstation trips, corporate travel, and group excursions. Combining comfort, safety, affordability, and professional service, it caters to families, tourists, corporate clients, and groups seeking reliable and convenient bus transportation in and around Indapur."
}
],
"tableData": [
["Bus On Rent in Indapur", "Bus Hire Indapur"],
["AC Bus Indapur", "Luxury Bus Indapur"],
["Wedding Bus Indapur", "Corporate Bus Indapur"],
["Outstation Bus Indapur", "Affordable Bus Indapur"],
["Chauffeur Driven Bus Indapur", "Best Bus Service Indapur"],
["Tourist Bus Indapur", "Group Travel Bus Indapur"],
["Online Bus Booking Indapur", "Event Bus Indapur"],
["Indapur Travel Bus", "—"]
]
,



"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Indapur with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable bus rental services in Indapur, perfect for group outings, family trips, school tours, and corporate travel."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air‑conditioned, and regularly serviced to ensure a smooth and enjoyable journey throughout Indapur and nearby destinations."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Indapur routes, ensuring safe, punctual, and stress‑free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for bus rentals in Indapur, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your bus rental in Indapur."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized rental packages based on your group’s needs and travel schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus rentals in Indapur."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Indapur?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Indapur for various travel needs.'
  },
  {
    question: 'How can I book a bus in Indapur?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rent in Indapur?',
    answer: 'Sanavi Travels offers a variety of buses including mini buses, 20‑seater, 32‑seater, 45‑seater, and 50‑seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with routes around Indapur?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Indapur routes, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations in Indapur?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Indapur and nearby areas.'
  },
  {
    question: 'Is the bus service in Indapur available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock bus rental services in Indapur to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus rental bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip in Indapur.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anand Deshmukh',
    feedback: 'Rented a bus in Indapur from Sanavi Travels — very comfortable journey and excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Meera Patil',
    feedback: 'Sanavi Travels provided a clean and reliable bus for our Indapur trip. Highly recommended!',
    rating: 5
  }
];
















































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Bus On Rent in Indapur - Sanavi Travels",
  "description": "Sanavi Travels offers AC, luxury, wedding, corporate, and outstation buses on rent in Indapur. Chauffeur-driven buses for tourist trips, group travel, events, and online booking with reliable service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "33"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Bus On Rent in Indapur | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels offers AC, luxury, wedding, corporate, and outstation buses on rent in Indapur. Chauffeur-driven buses for tourist trips, group travel, events, and online booking with reliable service."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/137.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinindapur;